import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: 'input[appAlphaNumeric]'
})
export class AlphaNumericDirective {

  constructor() { }
  @HostListener('keypress') onkeypress(e) {
    const event = e || window.event;
    if (event) {
      return this.alfanumeric(event);
    }
  }

  alfanumeric(event: any) {
    const exp = /[\w._\-@,]/g;
    const inputChar = String.fromCharCode(event.charCode);
    return exp.test(inputChar);
  }

}
